import { BUSINESS_TYPES } from './types';

// { label: 'Automotive', value: 'Automotive' },
// { label: 'Fitness', value: 'Fitness' },
// { label: 'Grocery', value: 'Grocery' },
// { label: 'Hotel', value: 'Hotel' },
// { label: 'Medical Offices', value: 'Medical Offices' },
// { label: 'Restaurants', value: 'Restaurants' },
// { label: 'Retail Stores', value: 'Retail Stores' },
// { label: 'Spas', value: 'Spas' },
// { label: 'Other', value: 'Other' },
const CHECK_ORDER = [
  'Automotive',
  'Fitness',
  'Grocery',
  'Spas',
  'Hotel',
  'Medical Offices',
  'Restaurants',
  'Retail Stores',
];

const BUSINESS_TYPE_KEYWORDS: Record<string, string[]> = {
  Automotive: ['auto', 'car'],
  Fitness: ['fitness', 'gym', 'yoga', 'sports'],
  Grocery: ['supermarket', 'grocery'],
  Spas: ['spa', 'massage', 'nail', 'hair', 'beauty', 'salon'],
  Hotel: ['hotel', 'motel', 'lodging'],
  'Medical Offices': ['medical', 'doctor', 'hospital', 'clinic', 'health', 'dentist'],
  Restaurants: [
    'restaurant',
    'food',
    'dining',
    'bar',
    'pub',
    'cafe',
    'coffee',
    'breakfast',
    'lunch',
    'dinner',
    'brunch',
  ],
  'Retail Stores': ['store', 'shop', 'retail'],
};

// Helper function to check if two arrays have any common elements
function hasIntersection(arr1: string[], arr2: string[]): boolean {
  return arr1.some((item) => arr2.includes(item));
}

export function getBusinessType(tags: string[]) {
  const lowerTags = tags.map((tag) => tag.toLowerCase().split(' '));

  for (const businessType of CHECK_ORDER) {
    const keywords = BUSINESS_TYPE_KEYWORDS[businessType];
    if (!keywords) {
      continue;
    }

    for (const tagWords of lowerTags) {
      if (hasIntersection(keywords, tagWords)) {
        return businessType;
      }
    }
  }

  return undefined;
}
